require('./brokerRightsSellSuccessStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @constants
const {
    FIRST_STEP,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    EURO_TEXT,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_CORPORATE_OPERATIONS_URL
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
// @utilities
const DateHelper = require('utilities/dateHelper');
const { getFormattedString, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class BrokerRightsSellSuccessStep extends React.Component {
    render() {
        const { immBrokerRightsSell, immCorporatesOperations } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsSell.get(
            'selectedCorporateOperationIndex'
        );
        const selectedCorporateOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            selectedCorporateOperationIndex
        ]);
        const title = formatText('broker-rightsSellSuccessTitle');
        const subTitle = formatText('broker-rightsSellSuccessSubtitle', [
            immBrokerRightsSell.get('orderNumber')
        ]);
        const mainButtonLabel = formatText('broker-rightsSellSuccessMainButtonLabel').toUpperCase();
        const mainButtonLink = `/myprofile/broker`;
        const mainButton = {
            label: mainButtonLabel,
            url: mainButtonLink,
            modifier: "secondary"
        };
        const secondaryButtonLabel = formatText('broker-rightsSellSuccessSecondaryButtonLabel');
        const secondaryButton = {
            label: secondaryButtonLabel,
            url: BROKER_CORPORATE_OPERATIONS_URL
        };
        const availableRights = Number(immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity']));
        const limitedValue = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue']);
        const formattedLimitedValue = getFormattedString({
            amount: limitedValue,
            decimalsLength: 3,
            currency: EURO_TEXT // @hardcoded
        });
        const orderTypeOption = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeOption']);
        const validityDate = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'validityDate']);
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const accountControlDigit = selectedContract.getIn(['cuenta', 'digitodecontrol']);
        const accountFullNumber = selectedContract.getIn(['cuenta', 'fullNumber']);
        const fullContractNumber = CHARGE_ACCOUNT_PREFIX + accountControlDigit + accountFullNumber;
        const plainAmountObject = getPlainAmountObject(selectedContract.getIn(['associatedAccount','balance']));
        let orderTypeText;

        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                orderTypeText = formatText('broker-rightsSellToMarketOrderType');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                orderTypeText = formatText('broker-rightsSellForTheBestOrderType');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                orderTypeText = formatText('broker-rightsSellSuccessLimitedOrderType', [formattedLimitedValue]);
                break;
        }

        return (
            <article className="broker-rights-sell-success row no-gutter">
                <div className="col-xs-12">
                    <WizardSuccess
                        successMessage={title}
                        successSubMessage={subTitle}
                        mainButton={mainButton}
                        secondaryButton={secondaryButton}
                    >
                        <section className="broker-rights-sell-success__info-section row">
                            <div className="col-lg-4 broker-rights-sell-success__titles-container-left">
                                <div>
                                    <OKInformativeList>
                                        <OKInformativeListItem
                                            title={formatText('broker-rightsSellValueLabel')}
                                            bodyText={selectedCorporateOperation.get(
                                                'descriptionValue'
                                            )}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('broker-rightsSellContractLabel')}
                                            bodyText={selectedContract.get('walletAccountType')}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        >
                                            <span className="broker-rights-sell-success__stock-container-info">
                                                <FormattedText value="broker-rightsSellSuccessStepContractNumber" injectedStrings={[fullContractNumber]} /><br/>
                                                <FormattedText value="broker-rightsSellSuccessStepHolder" injectedStrings={[selectedContract.get('owner')]} /><br/>
                                                <FormattedText value="broker-rightsSellSuccessAssociatedAccount" injectedStrings={[selectedContract.getIn(['associatedAccount', 'number'])]} /><br/>
                                                <FormattedText value="broker-rightsSellBalancePrefix" />
                                                <OneLineSymbolAmount
                                                    amountObject={plainAmountObject}
                                                    language={getLanguage()}
                                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                                />
                                                <FormattedText value="broker-rightsSellBalanceSuffix" />
                                            </span>
                                        </OKInformativeListItem>
                                    </OKInformativeList>
                                </div>
                            </div>

                            <div className="col-lg-8 broker-rights-sell-success__titles-container-right">
                                <div>
                                    <OKInformativeList>
                                        <OKInformativeListItem
                                            title={formatText(
                                                'broker-rightsSellAvailableRightsLabel'
                                            )}
                                            bodyText={availableRights}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                        <OKInformativeListItem
                                            title={formatText(
                                                'broker-rightsSellTermOfValidityLabel'
                                            )}
                                            bodyText={DateHelper.buildFormattedDate(
                                                validityDate,
                                                formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)
                                            )}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                        <OKInformativeListItem
                                            title={formatText('broker-rightsSellOrderTypeLabel')}
                                            bodyText={orderTypeText}
                                            columns={1}
                                            isUppercaseTitle={true}
                                        />
                                    </OKInformativeList>
                                </div>
                            </div>
                        </section>
                    </WizardSuccess>
                </div>
            </article>
        );
    }
}

BrokerRightsSellSuccessStep.propTypes = {
    immBrokerRightsSell: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired
};

module.exports = BrokerRightsSellSuccessStep;
